// Dev-only switch for expensive visual effects in the large schedule DnD board.
export const SCHEDULE_DND_PERFORMANCE_MODE = true;

export const MATCH_RENDER_BUFFER_PX = SCHEDULE_DND_PERFORMANCE_MODE ? 120 : 400;
